app.controller('GalleryController', ['$scope','$http','Config','CacheFactory','$rootScope','$timeout','helper', function($scope,$http,Config,CacheFactory,$rootScope,$timeout,helper){

	//if current page is not set then set it to first page
	// if(!angular.isDefined(CacheFactory.get('appCache').get('currentPage'))){
	// 	CacheFactory.get('appCache').put('currentPage',1);
	// }
	
	$scope.galleryImages = [];
	$scope.totalItems = 0;
  	// $scope.currentPage = CacheFactory.get('appCache').get('currentPage');
  	// $scope.perPage = 12;
	$scope.base_url = Config.base_url;
	$http.defaults.headers.common.authorization = Config.api_key;
	$scope.galleryInit = false;

	$scope.init = function(){
		helper.hideLoader();
		$scope.getGalleryImages();
	}

	// $scope.pageChanged = function(page){
	// 	$scope.currentPage = page;
	// 	$scope.galleryImages = [];
	// 	CacheFactory.get('appCache').put('currentPage',page);
	// 	$scope.getGalleryImages();
	// }

	$scope.initPhotoSwipe = function(idx,$event){
		$event.preventDefault();
        var pswpElement = document.querySelectorAll('.pswp')[0];

        // build items array
        var items=[];
        $('.gallery_img_link').each(function(key,item){

            items.push({
                src:item.href,
                w:800,
                h:800
            });
        });

        // define options (if needed)
        var options = {
            // optionName: 'option value'
            // for example:
			index: idx, // start at first slide
			preload:[1,1]
        };
        
        // Initializes and opens PhotoSwipe
        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
	}

	$scope.getGalleryImages = function(){
		helper.showTransLoader();
		width = 450;
		height = 450;
		zoom_width = 800;
		zoom_height = 800;
		// query_string = '?brand='+Config.brand_key+'&width='+width+'&height='+height+'&zoom-width='+zoom_width+'&zoom-height='+zoom_width+'&page='+$scope.currentPage+'&per-page='+$scope.perPage;
		query_string = '?brand='+Config.brand_key+'&width='+width+'&height='+height+'&zoom-width='+zoom_width+'&zoom-height='+zoom_width;

		$http({
		  method: 'GET',
		  url: Config.api_url+'gallery-images'+query_string,
		  headers:{
		  	'authorization':Config.api_key
		  }
		}).then(function(response) {
		   	$scope.galleryImages = response.data;
		   	// $scope.totalItems = response.data.total;
		   	// $scope.fromItem = response.data.from;
		   	// $scope.toItem = response.data.to;
		   	// $scope.perPage = response.data.per_page;
		   	// $scope.currentPage = response.data.current_page;
		   	$timeout(function () {
		   		helper.hideTransLoader();
		   		init();
			}, 100);

		  }, function(response) {
		    console.log(response);
		  });
	}

}]);
